import { render } from "./AppHeader.vue?vue&type=template&id=6b0744e3&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=ts"
export * from "./AppHeader.vue?vue&type=script&lang=ts"

import "./AppHeader.vue?vue&type=style&index=0&id=6b0744e3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6b0744e3"

export default script